import {
  initialState,
  Actions,
  State,
  EDIT_ACTIVITY,
  EDIT_ACTIVITY_SUCCESS,
  EDIT_ACTIVITY_ERROR,
  RESET_EDIT_ACTIVITY,
} from "../../types/activity/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_ACTIVITY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_ACTIVITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_ACTIVITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_ACTIVITY:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
